<label class="file-upload-input-wrapper" [ngClass]="styleType === 'height_lg' ? 'height-lg' : 'height-sm'">
  <input #fileUpload type="file" class="file-upload-input" [accept]="accept || '.xml, .xls, .xlsx'" (change)="handleUploadReport($event.target.files)" [multiple]="multiple">
  <span mis-input-icon class="btn-icon"><img src="assets/uploadFile.svg" alt="" /></span>
  <span class="btn-text">{{labelText}}</span>
</label>
